<template>
    <v-container fluid>
        <v-row>
            <v-col md="6" offset-md="3" sm="8" offset-sm="2" class="pt-0">
                <v-form>
                    <h3 class="text-center title">
                        {{ t('reviews.formTitle') }}
                    </h3>
                    <v-text-field
                        v-model="author"
                        dense
                        :label="t('reviews.name')"
                        prepend-icon="mdi-account"
                    />
                    <v-textarea
                        v-model="text"
                        dense
                        counter
                        :label="t('reviews.text')"
                        prepend-icon="mdi-text"
                        rows="3"
                    />
                    <div class="g-recaptcha" data-sitekey="6LfaXc8ZAAAAAHdMF2Dmjxd9OJU_QN5InSzKo1YE"></div>
                    <!-- <br/> -->
                    <v-btn color="success" class="mt-2" @click="submit" :disabled="!firebaseEnabled">{{ t('reviews.submit') }}</v-btn>
                    <p v-if="formMessage" class="error--text mt-2 mb-0">{{ formMessage }}</p>
                </v-form>
            </v-col>
        </v-row>
        <h3 class="text-center title">
            {{ t('reviews.listTitle') }}
        </h3>
        <v-row>
            <v-col sm="10" offset-sm="1" class="pa-0">
                <v-card v-for="(review, index) in REVIEWS_STATE" :key="review.id" class="mb-2">
                    <v-card-title>
                        <p class="title pa-0 ma-0 align-self-center">{{ review.author }}</p>
                        <v-container class="d-flex pa-0" fluid>
                            <v-icon left small>mdi-clock</v-icon>
                            <p class="text-body-1 pa-0 ma-0 align-self-center">{{ formatDate(review.published) }}</p>
                            <v-btn v-if="LOGIN_STATE" icon class="align-self-center" @click="deleteReview(review.id, index)">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-container>
                    </v-card-title>
                    <v-card-text>
                        <p class="text-body-1 ma-0 text-justify" style="text-indent: 2em">{{ review.text }}</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { db, firebaseEnabled } from '@/fb'
import { mapGetters, mapMutations } from 'vuex'

export default {
    data: () => ({
        firebaseEnabled,
        author: '',
        text: '',
        formMessage: ''
    }),
    methods: {
        ...mapMutations(['PUSH_REVIEW', 'REMOVE_REVIEW']),
        async submit() {
            if (!this.firebaseEnabled || !db) {
                this.formMessage = this.t('reviews.unavailable')
                return
            }

            if (!window.grecaptcha || typeof window.grecaptcha.getResponse !== 'function') {
                this.formMessage = this.t('reviews.recaptchaRequired')
                return
            }

            // const captchaResponse = grecaptcha.getResponse()
            console.log(window.grecaptcha.getResponse())

            if (window.grecaptcha.getResponse()) {
                this.formMessage = ''

                try {
                    // send review here
                    const newReview = { author: this.author, text: this.text.replace(/↵/g, '\n'), published: new Date() }

                    console.log(newReview)

                    const id = (await db.collection('reviews').add(newReview)).id

                    this.PUSH_REVIEW({ value: { id, ...newReview }, method: 'unshift' })

                    this.author = this.text = ''

                    // parsing function of reviews in original site
                    // [...document.querySelectorAll('.commentstd')].slice(1).map((el) => ({
                    //     name: (el.querySelector('.com-meta strong') || el.querySelector('.com-meta a')).innerText,
                    //     published: el.querySelector('.com-meta em').innerText,
                    //     text: el.querySelector('.commententry').innerText
                    // }))

                    // for (let review of this.reviews) {
                    //     review.published = new Date(review.published)
                    //     await db.collection('reviews').add(review)
                    // }

                    window.grecaptcha.reset()
                } catch (error) {
                    console.error(error)
                    this.formMessage = this.t('reviews.unavailable')
                }
            } else {
                this.formMessage = this.t('reviews.recaptchaRequired')
            }
        },
        async deleteReview(id, index) {
            if (!this.firebaseEnabled || !db) {
                return
            }

            try {
                await db.collection('reviews').doc(id).delete()
                this.REMOVE_REVIEW(index)
            } catch (error) {
                console.error(error)
            }
        }
    },
    computed: {
        ...mapGetters(['LOGIN_STATE', 'REVIEWS_STATE'])
    },
    mounted() {
        if (!this.firebaseEnabled || window.grecaptcha || document.querySelector('script[src="https://www.google.com/recaptcha/api.js"]')) {
            return
        }

        const recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
        recaptchaScript.async = recaptchaScript.defer = true
        document.head.appendChild(recaptchaScript)
    }
}
</script>